import React, { useEffect, useState } from "react";
import styles from "./CountdownTimer.module.css";
import { AccessTime as TimerOutlinedIcon } from 'components/ui/IconAdapter';

const CountdownTimer = ({ exam }) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [timeUnit, setTimeUnit] = useState("");
  console.log("Exam data received:", exam);
  useEffect(() => {
    if (exam?.exam?.duration && exam?.exam?.durationType) {
      setTimeLeft(exam.exam?.duration * getMultiplier(exam.exam?.durationType));
      setTimeUnit(exam.exam?.durationType);
    }

    const interval = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft === 0) {
          clearInterval(interval);
          //   Instead of clearing localStorage, just trigger your action here
          // Example: redirect to feedback page
          // window.location.href = "/feedback";
          return 0;
        } else {
          return prevTimeLeft - 1;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [exam]);

  const getMultiplier = (type) => {
    switch (type) {
      case "Days":
        return 24 * 60 * 60;
      case "Hours":
        return 60 * 60;
      case "Minutes":
        return 60;
      default:
        return 1;
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    if (timeUnit === "Days") {
      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;
      return `${days} Days ${remainingHours} Hours ${minutes} Minutes ${seconds} Seconds`;
    } else if (timeUnit === "Hours") {
      return `${hours} Hours ${minutes} Minutes ${seconds} Seconds`;
    } else if (timeUnit === "Minutes") {
      return `${minutes} Minutes ${seconds} Seconds`;
    } else {
      return `${hours} Hours ${minutes} Minutes ${seconds} Seconds`;
    }
  };

  const timerTextStyle = {
    color: timeLeft <= 300 ? 'red' : 'inherit'
  };

  return (
    <div className={styles.timerContainer}>
      <b>
        <div className={styles.timerText} style={timerTextStyle}>
          {formatTime(timeLeft)} <TimerOutlinedIcon style={{ paddingBottom: '2px' }} />
        </div>
      </b>
    </div>
  );
};

export default CountdownTimer;
